import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import * as colors from '../../../../Util/Colors';
import { formatMetricName, getBenchmarkSuffix } from './helper';
import CustomLegendIcon from './CustomLegendIcon';
import { getMetricStringIdAndDefaultMessage } from '../LighthouseMetrics/helper';
// import styles from './ViewStyle.module.css';
interface CustomLegendProps {
  payload: Record<string, any>[];
}

const CustomLegend: React.FC<CustomLegendProps> = ({
  payload,
}: CustomLegendProps): React.ReactElement => {
  const intl = useIntl();
  //   payload.reverse();
  return (
    <>
      {payload.map((entry, index) => (
        <>
          {/* <span style={{ display: 'inline-block' }}> */}
          {/* <span style={{ whiteSpace: 'nowrap' }}> */}
          <span style={{ wordBreak: 'keep-all' }}>
            <CustomLegendIcon
              fill={colors.primaryFill}
              color={entry.color}
              value={
                intl.formatMessage({
                  ...getMetricStringIdAndDefaultMessage(
                    entry.value.replace('#netavg', '')
                  ),
                }) + getBenchmarkSuffix(entry.value)
              }
            />{' '}
            {/* <FormattedMessage
            {...getMetricStringIdAndDefaultMessage(
              entry.value.replace('#netavg', '')
            )}
          /> */}
            {/* <span style={{ color: 'black' }}>
            {formatMetricName(entry.value)}
            {' '}
          </span> */}
          </span>
        </>
      ))}
    </>
  );
};

export default CustomLegend;
